import React, { Component } from "react";
import {
  View,
  StatusBar,
  Text,
  TouchableOpacity,
  Image,
} from "react-native-web";
import BackgroundImage from "../components/BackgroundImage";
import HeaderBar from "../components/HeaderBar";
import gql from "graphql-tag";
import { withRouter } from "react-router";
import { LoadingOverlay } from "../components/Overlay";
import ApolloClient from "apollo-boost";
import queryString from "query-string";
import { FormModal } from "../components/Modal";
import { ApolloConsumer, Query, Mutation } from "react-apollo";
import { withI18n, translate } from "../libs/withI18n";
import { addNotification } from "../App";
import { handleError } from "../libs/errors";
import firebaseConfig from "../firebaseConfig.json";
import "firebase/messaging";
import firebase from "firebase/app";

let urlValues;

class ListStudent extends Component {
  state = {
    uniqueCode: "",
    Student: {
      name: "Indra",
      regNumber: 192838383,
    },
    deleteStudentModalVisible: false,
    session: {},
    loading: false,
    accountSession: null,
  };

  refresh = () => {
    window.location.reload();
  };

  handleConfirmDeleteStudent = (student) => (e) => {
    if (e) e.preventDefault();
    this.setState({
      Student: student,
      deleteStudentModalVisible: true,
    });
  };

  closeDeleteStudentModal = (e) => {
    if (e) e.preventDefault();
    this.setState({
      deleteStudentModalVisible: false,
    });
  };

  handleSubmitDeleteStudent = async (e) => {
    if (e) e.preventDefault();
    const { Student } = this.state;
    try {
      let fcmToken = "";
      if (!firebase.apps.length) {
        // console.log("Initialize firebase...");
        firebase.initializeApp(firebaseConfig);
      }
      if (firebase.messaging.isSupported()) {
        const messaging = firebase.messaging();
        fcmToken = await messaging.getToken();
      }
      await this.props.unclaimStudentForAccount({
        variables: {
          studentId: Student._id,
          fcmToken,
        },
      });

      this.props.refetch();

      addNotification({
        title: "SUCCESS",
        message: `${this.props.translate("Berhasil menghapus siswa")} ${
          Student.name
        }`,
        level: "success",
      });
    } catch (e) {
      console.log(e);
      if (e.message.indexOf("Invalid student!") > -1) {
        this.setState({
          Student: null,
          Errors: e.message,
          loading: false,
        });
        handleError({
          message: "Siswa tidak bisa dihapus!",
        });
      }
    }
    this.setState({
      deleteStudentModalVisible: false,
    });
  };

  render() {
    const { Student, Errors, loading } = this.state;
    const { allStudents = [] } = this.props;
    urlValues = queryString.parse(this.props.location.search);
    return (
      <View style={{ flex: 1 }}>
        <div className="fixed-top">
          <StatusBar
            backgroundColor="#1696ff"
            barStyle="light-content"
            animated={true}
          />
        </div>
        <style jsx>
          {`
            .td-ellipsis {
              position: relative;
            }
            .td-ellipsis:before {
              content: "&nbsp;";
              visibility: hidden;
            }
            .td-ellipsis span {
              position: absolute;
              left: 0;
              right: 0;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          `}
        </style>
        <LoadingOverlay visible={loading} />
        <BackgroundImage />

        <FormModal
          title={
            <span>
              <i className="fa fa-trash-alt" /> {translate("Hapus Siswa")}
            </span>
          }
          visible={this.state.deleteStudentModalVisible}
          size="md"
          onClose={this.closeDeleteStudentModal}
          onSubmit={this.handleSubmitDeleteStudent}
          verticalCentered={true}
        >
          <div className="text-center">
            {translate("Apakah anda yakin untuk menghapus siswa atas nama")}{" "}
            <b>{Student ? Student.name : ""}</b>?
          </div>
        </FormModal>

        <div className="fixed-top">
          <HeaderBar
            title={
              <Text>
                <i
                  className="fa fa-users"
                  style={{
                    fontSize: 20,
                  }}
                />{" "}
                {translate("Daftar Siswa")}
              </Text>
            }
            right={
              <TouchableOpacity onPress={this.refresh}>
                <Text
                  style={{
                    paddingRight: 12,
                    paddingLeft: 20,
                    color: "white",
                    fontSize: 16,
                    paddingVertical: 2,
                  }}
                >
                  <i
                    className="fa fa-sync-alt"
                    style={{
                      fontSize: 20,
                      marginBottom: 5,
                    }}
                  />
                </Text>
              </TouchableOpacity>
            }
          />
        </div>
        {allStudents.map((student, indexStudent) => (
          <div
            key={student._id}
            className="card"
            style={{
              borderRadius: "20px",
              margin: `${
                indexStudent === 0 ? "5rem 15px 1rem 15px" : "0 15px 1rem 15px"
              }`,
            }}
          >
            <div className="card-body">
              <div
                className="box-right"
                style={{
                  width: "8%",
                  position: "absolute",
                  top: 0,
                  right: 0,
                  bottom: 0,
                  borderRadius: "0 20px 20px 0",
                  textAlign: "center",
                  backgroundColor: "#e84118",
                }}
              >
                <div
                  className="icon-box"
                  onClick={this.handleConfirmDeleteStudent(student)}
                  style={{
                    position: "absolute",
                    left: 0,
                    top: "50%",
                    transform: "translateY(-50%)",
                    height: "20px",
                    width: "100%",
                    color: "#fff",
                  }}
                >
                  <i className="fa fa-trash-alt" />
                </div>
              </div>
              <div>
                <table className="w-100">
                  <thead>
                    <tr>
                      <th width="20%" />
                      <th width="5%" />
                      <th width="67%" />
                      <th width="8%" />
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <b>{translate("Nama")}</b>
                      </td>
                      <td>:</td>
                      <td className="td-ellipsis">
                        <span>{student.name}</span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <b>NIS</b>
                      </td>
                      <td>:</td>
                      <td>{student.regNumber}</td>
                    </tr>
                    <tr>
                      <td>
                        <b>{translate("Sekolah")}</b>
                      </td>
                      <td>:</td>
                      <td>
                        {student.SchoolInformation
                          ? student.SchoolInformation.name
                          : ""}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        ))}
        <hr />
        <div className="fixed-bottom">
          <TouchableOpacity
            onPress={() =>
              this.props.history.push({
                pathname: "/claim_student",
              })
            }
          >
            <button
              type="button"
              style={{
                zIndex: 9999,
                backgroundColor: "#00a8ff",
                height: 50,
                borderWidth: 0,
                borderRadius: 0,
                boxShadow: "0px -2px 5px 2px #ddd",
              }}
              className="btn btn-lg btn-primary btn-block"
            >
              <Text
                style={{
                  color: "white",
                  fontSize: 20,
                }}
              >
                <i className="fa fa-arrow-left" /> {translate("Kembali")}
              </Text>
            </button>
          </TouchableOpacity>
        </div>
      </View>
    );
  }
}

const mwvClient = new ApolloClient({
  uri: "https://api.mwv.softwaresekolah.co.id/graphql",
  // uri: 'http://localhost:9001/graphql'
});

const LIST_STUDENTS = gql`
  query listQuery(
    $_id: String
    $semester: String
    $academicYear: String
    $studentId: String
    $subjectId: String
  ) {
    allStudentBySessionId(sessionId: $_id) {
      _id
      name
      regNumber
      SchoolInformation {
        _id
        name
      }
      photoUrl
      PREFIX
    }
    allAcademicScores(
      semester: $semester
      academicYear: $academicYear
      studentId: $studentId
      subjectId: $subjectId
    ) {
      _id
      score
      assessmentCategoryName
      assessmentTypeName
      CurriculumName
      KKMScore
      Subject {
        _id
        name
      }
      AcademicCompetence {
        _id
        description
      }
      AcademicCompetenceIndicator {
        _id
        description
      }
      _createdAt
    }
  }
`;
const UNCLAIM_STUDENT = gql`
  mutation unclaimStudentForAccount($studentId: ID!, $fcmToken: String) {
    unclaimStudentForAccount(studentId: $studentId, fcmToken: $fcmToken)
  }
`;
export default withRouter(
  withI18n("list_students")((props) => {
    urlValues = queryString.parse(props.location.search);
    let semester = urlValues.semester;
    let academicYear = urlValues.academicYear;
    let studentId = urlValues.studentId;
    let subjectId = urlValues.subjectId ? urlValues.subjectId : "";
    return (
      <ApolloConsumer>
        {(client) => (
          <Mutation mutation={UNCLAIM_STUDENT}>
            {(unclaimStudentForAccount) => (
              <Query
                query={LIST_STUDENTS}
                client={mwvClient}
                variables={{
                  _id: urlValues.sessionId,
                  semester,
                  academicYear,
                  studentId,
                  subjectId,
                }}
              >
                {({ error, loading, data, refetch }) => (
                  <div>
                    {/* {console.log(data)} */}
                    <ListStudent
                      {...props}
                      error={error}
                      loading={loading}
                      refetch={refetch}
                      allStudents={
                        data && data.allStudentBySessionId
                          ? data.allStudentBySessionId
                          : []
                      }
                      allAcademicScores={
                        data && data.allAcademicScores
                          ? data.allAcademicScores
                          : []
                      }
                      unclaimStudentForAccount={unclaimStudentForAccount}
                    />
                  </div>
                )}
              </Query>
            )}
          </Mutation>
        )}
      </ApolloConsumer>
    );
  })
);
